import { TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  editLanguagesSubmitted(data) {
    return {
      Edition: data.editionType,
    };
  },

  languageStatusChanged(data: { enabled: boolean }) {
    return {
      Status: data.enabled ? 'live' : 'not live',
    };
  },

  setBulkPreferencesFiltered(data: { filters: string }) {
    return {
      Filter: data.filters,
    };
  },
};

export default Transforms;
